<template>
  <!--弹框2 开始-->
  <div class="dia-info">
    <el-dialog :visible.sync="frameHotelSoldDialog" top="35vh" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :width="frameWidth" :show-close="showClo" center class="textcenter">
      <div style="width:100%;text-align: center;">
        <div style="height: 120px;"><img src="/static/img/frame/sold-blue.png" class="frame-big-img"></div>
        <div class="frame-text-hotel-sold wordBreak">
          Oops! The selected hotel is fully booked for your chosen dates. Let's explore quotes from other available hotels instead. Thank you for your understanding.
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button class="booknow_button" style="float: none; width: 155px;" @click="cityRouterLink">Home</el-button>
      </span>
    </el-dialog>
  </div>
  <!--弹框2 结束-->
  <!--引入方式-->
  <!-- <frameHotelSold :frameHotelSoldDialog="frameHotelSoldDialog"></frameHotelSold> -->
</template>

<script>
import { getCityId } from '@/request/hotel.js'
export default {
  name: 'frameHotelSold',
  props: ['frameHotelSoldDialog', 'checkIn', 'checkOut', 'nationality'],
  data () {
    return {
      frameWidth: '450px',
      showClo: false,
      city: {},
      adult: 2,
      child: 0,
      room: 1,
      startdate: '',
      enddate: '',
      hotelid: ''
    }
  },
  created () {
    var query = this.$route.query
    if (JSON.stringify(query) !== '{}') {
      this.adult = parseInt(this.$route.query.adult)
      this.child = parseInt(this.$route.query.child)
      this.room = parseInt(this.$route.query.room)

      this.startdate = this.$route.query.start_date
      this.enddate = this.$route.query.end_date
    } else {
      var params = this.$route.params
      var searchData = localStorage.getItem('searchData')
      if (JSON.stringify(params) === '{}' && searchData !== '{}' && searchData !== null) {
        params = JSON.parse(searchData)
      }
      if (JSON.stringify(params) !== '{}' || (searchData !== '{}' && searchData !== null)) {
        this.adult = parseInt(params.adult)
        this.child = parseInt(params.child)
        this.room = parseInt(params.room)
        this.startdate = params.start_date
        this.enddate = params.end_date
      }
    }
    // 获取城市ID
    this.getCityIdFun()
  },
  mounted () {
    if (document.body.clientWidth < 1001) {
      this.frameWidth = '95%'
    } else {
      this.frameWidth = '450px'
    }
  },
  methods: {
    // 获取城市ID
    getCityIdFun: function () {
      var query = this.$route.query
      if (JSON.stringify(query) !== '{}' && query.hotelid !== undefined) {
        this.hotelid = this.$route.query.hotelid
      } else {
        var params = this.$route.params
        var orderData = localStorage.getItem('orderData')
        if (JSON.stringify(params) === '{}' && orderData !== '{}') {
          params = JSON.parse(orderData)
        }
        this.hotelid = params.hotelid
      }

      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      var DataJson = {'hotelid': this.hotelid, 'operation': 'getCityId', 'time': time, 'sessionid': sessionid}
      var Data = this.common.encryptionData(DataJson, this)
      getCityId(Data).then(res => {
        this.city = res.data.hotelCity
      })
    },
    // 城市跳转
    cityRouterLink: function () {
      // 点击返回首页 埋点记录
      this.clickPageAction('back_home', '', {'type': 'frameHotelSold'})

      var regionSel = {'value_en': this.city.city, 'value_zh': this.city.chinese_name, 'type_id': 1, 'type_data_id': this.city.id}
      sessionStorage.setItem('regionSel', JSON.stringify(regionSel))
      var nationality = ''
      var cityname = this.city.city
      if (this.common.languageSet(this) === 'zh') {
        cityname = this.city.chinese_name
      }

      let d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth()
      var tian = d.getDate()
      var monthSelect = (month + 1) < 10 ? '0' + (month + 1).toString() : (month + 1).toString()
      var startDate = this.startdate
      if (this.startdate === '' || this.startdate === undefined) {
        startDate = year + '-' + monthSelect + '-' + (parseInt(tian) + 1)
      }
      var endDate = this.enddate
      if (this.enddate === '' || this.enddate === undefined) {
        endDate = year + '-' + monthSelect + '-' + (parseInt(tian) + 2)
      }

      var params = this.$route.params
      if (JSON.stringify(params) === '{}') {
        params = this.$route.query
      }
      var searchData = localStorage.getItem('searchData')
      if (JSON.stringify(params) === '{}' && searchData !== '{}' && searchData !== null) {
        params = JSON.parse(searchData)
      }
      var childNums = '[]'
      if (JSON.stringify(params) !== '{}' && JSON.stringify(params.childNums) !== '{}' && params.childNums !== undefined) {
        childNums = params.childNums
      }
      if (JSON.stringify(params) !== '{}' && JSON.stringify(params.start_date) !== '' && JSON.stringify(params.start_date) !== undefined && JSON.stringify(params.end_date) !== '' && JSON.stringify(params.end_date) !== undefined) {
        startDate = params.start_date
        endDate = params.end_date
      }
      if (this.checkIn !== null && this.checkIn !== undefined) {
        startDate = this.checkIn
        endDate = this.checkOut
      }
      if (this.nationality !== null && this.nationality !== undefined) {
        nationality = this.nationality
      }
      var searchJson = {'type': 1, 'type_id': this.city.id, 'region': cityname, 'start_date': startDate, 'end_date': endDate, 'room': params.room, 'adult': params.adult, 'child': params.child, 'childNums': childNums, 'nationality': nationality}
      localStorage.setItem('searchData', JSON.stringify(searchJson))
      this.$router.push({name: 'HotelList', query: searchJson})
    }
  }
}
</script>

<style scoped>
.textcenter{text-align: center;}
.frame-big-img{width:100px; height:100px;cursor: pointer;}
.frame-text-hotel-sold{height:70px; font-size: 16px;color: #4F4C4C;text-align: center;}
.dia-info /deep/ .el-dialog__header{padding: 0;}
</style>



// WEBPACK FOOTER //
// src/components/public/frameHotelSold.vue